import React from 'react';
import './TermsOfService.css';

const TermsOfService = () => {
    return (
        <div className="terms-container">
            <div className="terms-content">
                <h1>Terms of Service for Number Paint: Coloring App</h1>
                <h2>1. Introduction</h2>
                <p>
                    Welcome to the Number Paint: Coloring App ("the App"). By downloading or using the App, you agree to comply with and be bound by these Terms of Service ("Terms"). If you do not agree to these Terms, please do not use the App.
                </p>
                <h2>2. Description of the App</h2>
                <p>
                    The App allows users to create paint-by-number images by uploading photos or using the camera feature. It also offers a library of pre-built images for coloring enjoyment. For users under 13, certain features such as the camera and image upload functionalities are disabled to comply with child privacy regulations.
                </p>
                <h2>3. User Conduct</h2>
                <p>By using the App, you agree not to:</p>
                <ul>
                    <li>Violate any applicable laws or regulations.</li>
                    <li>Upload content that is offensive, defamatory, or infringes on intellectual property rights.</li>
                    <li>Interfere with the App’s functionality or attempt to gain unauthorized access to its systems.</li>
                </ul>
                <h2>4. User Age and Parental Consent</h2>
                <p>
                    By using the App, you affirm that you are at least 13 years old, or if under 13, you are using the App with verifiable parental consent. We comply with the Children's Online Privacy Protection Act (COPPA) and require parental consent for users under 13. Parents can review, delete, or refuse further collection of their child's personal information by contacting us at <a href="mailto:numberpaintcoloringgame@gmail.com">numberpaintcoloringgame@gmail.com</a>.
                </p>
                <h2>5. Intellectual Property</h2>
                <p>
                    All content within the App, including images, text, graphics, and other materials, is the property of the App's developers or licensors. You are granted a limited, non-exclusive license to use the App for personal, non-commercial purposes.
                </p>
                <h2>6. Privacy Policy</h2>
                <p>
                    Your use of the App is also governed by our <a href="/privacy-policy">Privacy Policy</a>, which explains how we collect, use, and protect your information, including compliance with COPPA for users under 13.
                </p>
                <h2>7. Limitation of Liability</h2>
                <p>
                    The App is provided "as is" without warranties of any kind. We are not liable for any damages arising from your use of the App or your inability to use it.
                </p>
                <h2>8. Modifications to the Terms</h2>
                <p>
                    We reserve the right to update or modify these Terms at any time. Changes will be effective upon posting within the App. Your continued use of the App signifies your acceptance of the updated Terms.
                </p>
                <h2>9. Governing Law</h2>
                <p>
                    These Terms are governed by and construed in accordance with the laws of Sri Lanka, without regard to its conflict of law principles.
                </p>
                <h2>10. Termination</h2>
                <p>
                    We reserve the right to terminate or suspend your access to the App at our discretion, without notice, for conduct that violates these Terms or is otherwise harmful to other users or the App.
                </p>
                <h2>11. Contact Us</h2>
                <p>
                    If you have any questions or concerns regarding these Terms, please contact us at <a href="mailto:numberpaintcoloringgame@gmail.com">numberpaintcoloringgame@gmail.com</a>.
                </p>
                <p>
                    By using the Number Paint: Coloring App, you agree to these Terms of Service.
                </p>
            </div>
        </div>
    );
};

export default TermsOfService;
